import {inject, Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

import {ValLangueService} from "../../../../../val-definitions-communes-lib/src/public-api";

//Pipe de transformation d’un texte.
//Impur pour suivre le changement de langue des balises [TRD|clé|texte] : le HTML est recalculé à
//chaque détection, mais le SafeHtml n’est renouvelé que si le HTML a changé, sans quoi le DOM
//serait réécrit à chaque cycle.
@Pipe (
{
  name: 'val_markdown',
  pure: false
})
export class MarkdownPipe implements PipeTransform
{
  private valLangueService = inject (ValLangueService);

  //Création
  //  Paramètres
  //    domSanitizer : DomSanitizer
  constructor (private domSanitizer: DomSanitizer)
  {
    this.dernierHtml = null;
    this.dernierResultat = null;
  }

  //Dernier HTML calculé
  private dernierHtml: string | null;

  //Dernier résultat retourné
  private dernierResultat: SafeHtml | null;

  //Transforme le texte
  //  Paramètres
  //    value : Texte à transformer
  //  Retourne
  //    Html
  public transform (value: string) : SafeHtml
  {
    let html: string;

    if (value)
    {
      //[TRD|clé|texte] d’abord : la balise se loge dans le texte d’un [COL|…], dont le premier ] la couperait.
      //La clé est lue depuis la racine des traductions de l’application ; absente, le texte est affiché
      html = value.replace (/\[TRD\|([^|\]]+)\|([^\]]*)\]/g, (_balise: string, cle: string, texte: string) => this.valLangueService.TraduireOuDefaut (cle, texte))
                  .replace (/^---$/gm, '<hr>')
                  .replace (/\[\C\O\L\|(.+?)\|(.+?)\]/g, '<span style="color: $1;">$2</span>')
                  .replace (/\[\I\C\O\|(.+?)\|(.+?)\]/g, '<i class="$1" style="color: $2;"></i>')
                  .replace (/^###### (.+)$/gm, '<h6 style="display: inline;">$1</h3>')            //Titre
                  .replace (/^##### (.+)$/gm, '<h5 style="display: inline;">$1</h3>')
                  .replace (/^#### (.+)$/gm, '<h4 style="display: inline;">$1</h3>')
                  .replace (/^### (.+)$/gm, '<h3 style="display: inline;">$1</h3>')
                  .replace (/^## (.+)$/gm, '<h2 style="display: inline;">$1</h2>')
                  .replace (/^# (.+)$/gm, '<h1 style="display: inline;">$1</h1>')
                  .replace (/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>')                //Gras + italique
                  .replace (/\*\*(.+?)\*\*/g, '<strong>$1</strong>')                             //Gras
                  .replace (/\*(.+?)\*/g, '<em>$1</em>');                                        //Italique
    }
    else
      html = "";

    if (html !== this.dernierHtml || !this.dernierResultat)
    {
      this.dernierHtml = html;
      this.dernierResultat = this.domSanitizer.bypassSecurityTrustHtml (html);
    }

    return this.dernierResultat;
  }
}
